// I18n is initialized in envs.js and available on window
// This function only sets the translations for the current locale
export default (locale, translations) => {
  window.I18n.translations = {
    [locale]: translations,
  };
};
